import { useState } from "react";
import { Link } from "react-router-dom";
import bg from '../../assets/images/backGround.webp';

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle login logic here
        console.log("Logging in with", { email, password });
    };

    return (
        <div className="h-screen bg-cover bg-center" style={{ backgroundImage: `url(${bg})` }}>
            <div className="flex min-h-screen items-center justify-center">
                <div className="w-full max-w-md p-8 space-y-6 bg-white shadow-lg rounded-lg">
                    <h2 className="text-center text-2xl font-bold">Login</h2>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-3 border rounded-lg bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <div>
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-4 py-3 border rounded-lg bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <div className="text-right">
                            <Link to="/forgotpassword" className="text-blue-600 hover:underline">
                                Forgot Password?
                            </Link>
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-blue-900 text-white py-3 rounded-lg font-semibold hover:bg-blue-800 transition"
                        >
                            Login
                        </button>
                    </form>
                    <p className="text-center">
                        Not a Member?{" "}
                        <Link to="/register" className="text-blue-600 hover:underline">
                            Register now
                        </Link>
                    </p>
                </div>
            </div>

            <div className="absolute bottom-6 right-6 text-right">
                <p className="text-white font-Montserrat text-2xl">Scholarty</p>
                <p className="text-white font-Montserrat">Your Academic Network</p>
            </div>
        </div>
    );
};

export default Login;
